module.exports = __webpack_public_path__ + "static/img/menu.1050d1ca.png";